module.exports = "/_next/static/images/atm_bersama-250f9e4701a5d9645b9f70cef4f2cf64.svg";